(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-refind"] && !Shopify.designMode) return;
  try {
    
  // Reuse the StickyHeader behaviour from the original header so scroll
  // hide/reveal continues to work and --header-height stays accurate for
  // anything below that depends on it. Registered under sticky-header-refind
  // so it can coexist with the legacy sections/header.liquid if ever re-enabled.
  if (!customElements.get('sticky-header-refind')) {
    class StickyHeader extends HTMLElement {
      constructor() { super(); }
      connectedCallback() {
        this.header = this;
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
        this.setHeaderHeight();
        // Save the bound handler + media-query refs so disconnectedCallback
        // can remove the listeners (theme-editor re-renders the section
        // repeatedly; without this the listeners pile up).
        this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
        this.headerHeightMQ = window.matchMedia('(max-width: 990px)');
        this.headerHeightMQ.addEventListener('change', this.setHeaderHeightHandler);
        // The nav drawer survives both breakpoints (single panel, two
        // triggers). Only the SHOP hover pane is desktop-only — close it
        // on resize-to-mobile so a stale `.is-open` state doesn't linger
        // on a now-hidden surface.
        this.desktopMQ = window.matchMedia('(min-width: 750px)');
        this.onDesktopMQChange = this.onDesktopMQChange.bind(this);
        this.desktopMQ.addEventListener('change', this.onDesktopMQChange);
        if (this.headerIsAlwaysSticky) this.classList.add('shopify-section-header-sticky');
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      }
      onDesktopMQChange(event) {
        // The nav drawer works at all breakpoints now, so we no longer
        // close it when crossing into desktop. We still close the hover
        // panes when crossing into mobile (their hover affordance is
        // desktop-only, and stranded `.is-open` would leak across resizes).
        //
        // Both panes, not just SHOP: .header-refind__primary goes
        // display:none below 750px, so an open pane never receives the
        // mouseleave that would close it and comes back open — with a
        // stale aria-expanded="true" — when the window widens again.
        // Any hover pane added here must join this list.
        if (!event.matches) {
          this.querySelectorAll('refind-shop-pane, refind-drops-pane').forEach((pane) => {
            if (typeof pane.close === 'function') pane.close();
          });
        }
      }
      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        if (this.headerHeightMQ) this.headerHeightMQ.removeEventListener('change', this.setHeaderHeightHandler);
        if (this.desktopMQ) this.desktopMQ.removeEventListener('change', this.onDesktopMQChange);
      }
      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this);
      }
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
      }
      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeSearchModal();
      }
      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.classList.add('shopify-section-header-sticky', 'animate');
        this.classList.remove('shopify-section-header-hidden');
      }
      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
      closeSearchModal() {
        this.searchModal = this.searchModal || this.querySelector('details-modal');
        if (this.searchModal) this.searchModal.close(false);
      }
    }
    customElements.define('sticky-header-refind', StickyHeader);
  }

  // <refind-shop-pane> — wraps the SHOP trigger and drives the nav drawer.
  // Hover/focus on SHOP opens the drawer; cursor moving from SHOP into the
  // panel keeps it open via a shared closeTimer. ESC closes; on touch /
  // no-hover devices a tap toggles instead of navigating.
  if (!customElements.get('refind-shop-pane')) {
    class RefindShopPane extends HTMLElement {
      constructor() {
        super();
        // Cursor "intent grace" window — long enough that a normal
        // diagonal traverse from SHOP to the drawer panel doesn't trip
        // the close before the panel's mouseenter cancels it. --dur-press
        // (150ms) was too tight; --dur-hover (300ms) tracks the same token
        // the drawer's open/close transition runs at, which keeps the
        // grace window in proportion to the visible motion.
        const dur = getComputedStyle(document.documentElement).getPropertyValue('--dur-hover').trim();
        this.closeDelay = parseInt(dur, 10) || 300;
        this.closeTimer = null;
        this.handleEnter = this.handleEnter.bind(this);
        this.handleLeave = this.handleLeave.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleTriggerClick = this.handleTriggerClick.bind(this);
      }
      connectedCallback() {
        this.trigger = this.querySelector('.header-refind__nav--shop');
        // Bind the panel's mouse/focus listeners eagerly so cursor or focus
        // crossing between SHOP and the drawer keeps it open. Re-bound on
        // each connect; if the theme editor swaps <nav-drawer>, this
        // element will reconnect and pick up the new panel reference.
        this.bindPanelListeners();

        this.addEventListener('mouseenter', this.handleEnter);
        this.addEventListener('mouseleave', this.handleLeave);
        this.addEventListener('focusin', this.handleEnter);
        this.addEventListener('focusout', this.handleLeave);
        this.addEventListener('keydown', this.handleKeydown);
        if (this.trigger) {
          this.trigger.addEventListener('click', this.handleTriggerClick);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        if (this.trigger) {
          this.trigger.removeEventListener('click', this.handleTriggerClick);
        }
        this.unbindPanelListeners();
      }
      // Lookups resolve at call time so a theme-editor re-render that
      // swaps <nav-drawer> doesn't leave us pointing at a detached node.
      get navDrawer() { return document.querySelector('nav-drawer'); }
      get details() { const nd = this.navDrawer; return nd && nd.querySelector('details'); }
      get panel() { const nd = this.navDrawer; return nd && nd.querySelector('.nav-drawer'); }
      bindPanelListeners() {
        const panel = this.panel;
        if (!panel || panel === this.boundPanel) return;
        this.unbindPanelListeners();
        // Both mouse and focus traversal between SHOP and the panel share a
        // single closeTimer: leaving either zone starts the close timer,
        // entering either cancels it. Without focus listeners on the panel
        // a keyboard user tabbing from SHOP into the drawer would trip the
        // shop-pane's focusout, closing the drawer mid-tab.
        panel.addEventListener('mouseenter', this.handleEnter);
        panel.addEventListener('mouseleave', this.handleLeave);
        panel.addEventListener('focusin', this.handleEnter);
        panel.addEventListener('focusout', this.handleLeave);
        this.boundPanel = panel;
      }
      unbindPanelListeners() {
        if (!this.boundPanel) return;
        this.boundPanel.removeEventListener('mouseenter', this.handleEnter);
        this.boundPanel.removeEventListener('mouseleave', this.handleLeave);
        this.boundPanel.removeEventListener('focusin', this.handleEnter);
        this.boundPanel.removeEventListener('focusout', this.handleLeave);
        this.boundPanel = null;
      }
      open() {
        clearTimeout(this.closeTimer);
        const nd = this.navDrawer;
        if (!nd) return;
        // Late-bind panel listeners if <nav-drawer> showed up after our
        // initial connect (theme editor staggered re-render).
        if (!this.boundPanel) this.bindPanelListeners();
        // Tell NavDrawer to restore focus to SHOP if the user later
        // presses ESC inside the drawer.
        nd.lastTrigger = this.trigger;
        // openFromHover skips focus trap + body scroll lock (both feel
        // jolty when the drawer is opened just because the cursor crossed
        // the SHOP zone). The mobile forwarder still goes through the
        // full MenuDrawer.openMenuDrawer path via summary.click() for
        // proper keyboard-driven focus management.
        nd.openFromHover();
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
      }
      close() {
        clearTimeout(this.closeTimer);
        const nd = this.navDrawer;
        if (!nd) return;
        nd.closeFromHover();
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      }
      handleEnter() {
        // ESC sets this flag so the synchronous focusin from trigger.focus()
        // doesn't immediately reopen the drawer the user just closed.
        if (this.suppressNextEnter) return;
        this.open();
      }
      handleLeave() {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          this.closeTimer = null;
          // Tested when the timer fires rather than when it is set, because
          // this handler serves focusout too and activeElement has not
          // settled at that point.
          //
          // The drawer's designer filter is the first thing inside the panel
          // a user dwells in with the keyboard, and the natural resting
          // motion once both hands are typing is to push the mouse aside.
          // That fires panel mouseleave, and without this the drawer would
          // slide shut mid-word and wipe the query with it. ESC still closes
          // from anywhere — handleKeydown calls close() directly.
          const panel = this.panel;
          if (panel && panel.contains(document.activeElement)) return;
          this.close();
        }, this.closeDelay);
      }
      handleKeydown(event) {
        if (event.key === 'Escape' && this.details && this.details.hasAttribute('open')) {
          this.suppressNextEnter = true;
          this.close();
          if (this.trigger) this.trigger.focus();
          setTimeout(() => { this.suppressNextEnter = false; }, 0);
        }
      }
      handleTriggerClick(event) {
        // Touch / no-hover devices: tap toggles the drawer instead of
        // navigating to the SHOP destination. Hover devices keep the
        // hover-to-open + click-to-navigate split intact.
        if (window.matchMedia('(hover: hover)').matches) return;
        event.preventDefault();
        if (this.details && this.details.hasAttribute('open')) {
          this.close();
        } else {
          this.open();
        }
      }
    }
    customElements.define('refind-shop-pane', RefindShopPane);
  }

  // <refind-drops-pane> — wraps EXCLUSIVE DROPS and its category menu.
  //
  // Simpler than RefindShopPane above despite looking like its twin: the panel
  // is a DOM child here, not a detached <nav-drawer>, so the browser's own
  // mouseenter/mouseleave already treat "cursor in the panel" as "cursor in the
  // pane". No panel-side listener bookkeeping, no lookups that have to survive
  // a theme-editor swap. The close timer is kept anyway — it covers the instant
  // where the cursor is between the label and the panel (the panel's
  // padding-top bridge covers the rest).
  if (!customElements.get('refind-drops-pane')) {
    // Element.matches() THROWS SyntaxError on a pseudo-class the engine doesn't
    // know, and :focus-visible only reached Safari in 15.4. Testing it once here
    // rather than in the focusin handler keeps that throw out of an event
    // listener, where it would silently break the keyboard path on older WebKit
    // while mouse hover carried on working.
    const SUPPORTS_FOCUS_VISIBLE = (() => {
      try {
        document.createElement('a').matches(':focus-visible');
        return true;
      } catch (e) {
        return false;
      }
    })();

    class RefindDropsPane extends HTMLElement {
      constructor() {
        super();
        // Same intent-grace window as the SHOP pane, read from the same token
        // so both menus close on the same beat.
        const dur = getComputedStyle(document.documentElement).getPropertyValue('--dur-hover').trim();
        this.closeDelay = parseInt(dur, 10) || 300;
        this.closeTimer = null;
        this.handleEnter = this.handleEnter.bind(this);
        this.handleLeave = this.handleLeave.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
      }
      connectedCallback() {
        this.trigger = this.querySelector('.header-refind__nav--live');
        this.menu = this.querySelector('.drops-menu');
        this.addEventListener('mouseenter', this.handleEnter);
        this.addEventListener('mouseleave', this.handleLeave);
        this.addEventListener('focusin', this.handleEnter);
        this.addEventListener('focusout', this.handleLeave);
        this.addEventListener('keydown', this.handleKeydown);
        if (this.menu) this.menu.addEventListener('click', this.handleMenuClick);
      }
      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        if (this.menu) this.menu.removeEventListener('click', this.handleMenuClick);
      }
      open() {
        clearTimeout(this.closeTimer);
        this.classList.add('is-open');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
      }
      close() {
        clearTimeout(this.closeTimer);
        this.classList.remove('is-open');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      }
      handleEnter(event) {
        // ESC sets this so the synchronous focusin from trigger.focus() doesn't
        // reopen the menu the user just closed.
        if (this.suppressNextEnter) return;
        if (event && event.type === 'focusin') {
          // Keyboard focus opens the menu; a tap that happens to focus the link
          // does not. Without this a touch user would watch the menu flash open
          // as the browser navigates away from the tap.
          //
          // Where :focus-visible isn't supported we can't tell the two apart,
          // so we open — the keyboard path staying reachable matters more than
          // a menu that flashes before a tap navigates away.
          const target = event.target;
          if (SUPPORTS_FOCUS_VISIBLE && target && typeof target.matches === 'function' && !target.matches(':focus-visible')) return;
        } else if (!window.matchMedia('(hover: hover)').matches) {
          // Touch devices synthesise mouseenter on tap. Nothing to open there —
          // the tap is already navigating to the page this menu links into.
          return;
        }
        this.open();
      }
      handleLeave() {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.close(), this.closeDelay);
      }
      handleKeydown(event) {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          this.suppressNextEnter = true;
          this.close();
          if (this.trigger) this.trigger.focus();
          setTimeout(() => { this.suppressNextEnter = false; }, 0);
        }
      }
      handleMenuClick(event) {
        if (!event.target.closest('.drops-menu__link')) return;
        // On the drops page already, a menu item is a same-document fragment
        // navigation: nothing unloads, so the menu would otherwise sit open
        // over the section it just scrolled to.
        this.close();
      }
    }
    customElements.define('refind-drops-pane', RefindDropsPane);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
